import React from "react";
import dynamic from "next/dynamic";
import Grid from "@mui/material/Grid";
import { CardAdd } from "iconsax-react";
import { useRouter } from "next/router";
import Button from "@mui/material/Button";
import GiftCreditsHistory from "./GiftCreditsHistory";
import { useGetAllUserFacility } from "src/services/new-facility";

import Pages from "src/constants/pages";
const Facility = dynamic(() => import("src/components/pages/facilities/Facility"));
const Loading = dynamic(() => import("src/components/pages/facilities/Facility/Loading"));
const EmptyFacility = dynamic(() => import("src/components/pages/facilities/Facility/EmptyFacility"));

const UserFacilities = () => {
	const { push, query } = useRouter();
	const layerId = query?.creditLayerId || "";
	const { data, isLoading } = useGetAllUserFacility();
	return (
		<Grid container spacing={2} my={2}>
			<Grid item xs={12} sm={12} display="flex" justifyContent="flex-end">
				<Button
					size="small"
					variant="contained"
					startIcon={<CardAdd />}
					sx={{ height: 35, mt: { xs: 2, md: 1 }, width: { xs: "fit-content", md: "auto" } }}
					onClick={() => push(`${Pages.SelectFacility}?creditLayerId=${layerId}`)}
				>
					ثبت درخواست جدید
				</Button>
			</Grid>
			<Grid item xs={12} sm={12}>
				{isLoading ? <Loading /> : data?.value && data?.value?.length > 0 ?
					<Facility data={data?.value} />
					:
					<EmptyFacility />
				}
			</Grid>
			<Grid item xs={12} sm={12}>
				<GiftCreditsHistory height={!data ? 85 : 320} />
			</Grid>
		</Grid>
	);
};
export default UserFacilities;